import ReCAPTCHA from "react-google-recaptcha";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

/**
 * Visible reCAPTCHA v2 checkbox wrapper using react-google-recaptcha.
 * Props:
 *  - siteKey (string): v2 site key (public)
 *  - onChange (function): receives token (string) or null on expire/error
 *  - onExpired, onError (optional): bubbles up events
 */
const ReCaptcha = ({
  siteKey,
  onChange,
  onExpired,
  onError,
  className = "",
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <div className={className}>
      <ReCAPTCHA
        sitekey={siteKey}
        onChange={onChange} // token => set in Formik
        onExpired={onExpired} // => clear token
        onErrored={onError} // -> note: library prop name is onErrored
        theme="light"
        size="normal"
      />
    </div>
  );
};

ReCaptcha.propTypes = {
  siteKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onExpired: PropTypes.func,
  onError: PropTypes.func,
  className: PropTypes.string,
};

export default ReCaptcha;
